import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { ResourceType } from "@common/types/auditLog";
import { HistoryDetailsBaseRow } from "../../cells/historyDetailsBaseRow";
import { LogTimeCell } from "../../cells/LogTimeCell";
import { HistoryCatalogItemDetailsColumn } from "./historyCatalogItemDetailsView";

export interface HistoryCatalogItemDetailsRow extends HistoryDetailsBaseRow {
    id: string;
    resourceType: ResourceType;
    resourceId: string;
    itemName: string;
    fieldLabel: string;
    previous: string;
    modified: string;
}

export const historyCatalogItemDetailsViewConfig: ViewConfig<
    HistoryCatalogItemDetailsRow,
    HistoryCatalogItemDetailsColumn,
    never
> = {
    columns: {
        [HistoryCatalogItemDetailsColumn.TIME]: {
            name: "Time",
            header: "",
            accessorKey: "logDate",
            cell: LogTimeCell,
            ...DATE_COLUMN_SIZE,
        },
        [HistoryCatalogItemDetailsColumn.ITEM_NAME]: {
            name: "Catalog item",
            header: "Catalog item",
            accessorKey: "itemName",
            minSize: 220,
            maxSize: 360,
        },
        [HistoryCatalogItemDetailsColumn.FIELD]: {
            name: "Field",
            header: "Field",
            accessorKey: "fieldLabel",
            minSize: 160,
            maxSize: 240,
        },
        [HistoryCatalogItemDetailsColumn.PREVIOUS]: {
            name: "Previous",
            header: "Previous",
            accessorKey: "previous",
            minSize: 280,
            maxSize: 420,
        },
        [HistoryCatalogItemDetailsColumn.MODIFIED]: {
            name: "Modified",
            header: "Modified",
            accessorKey: "modified",
            minSize: 280,
            maxSize: 420,
        },
    },
};
